import axios from "axios";

export const login = async (username, password) => {
  return await axios
    .post(`/api/webUsers/authenticate`, {
      username,
      password
    })
    .then(response => response.data);
}

export const refresh = async (token, refreshToken) => {
  return await axios
    .post(`/api/webUsers/refresh`, {
      token,
      refreshToken
    })
    .then(response => response.data);
}

// Invalidates every refresh token the user holds. Takes the pair in the body rather than relying on
// the Authorization header, because by the time anyone signs out the access token is often expired.
export const logout = async (token, refreshToken) => {
  return await axios
    .post(`/api/webUsers/logout`, {
      token,
      refreshToken
    })
    .then(response => response.data);
}

export const getLastPasswordResetForRelatedUser = (customerId) => {
  return axios.get(
    `/api/webUsers/getLastPasswordResetForRelatedUser?customerId=${customerId}`
  );
}

export const getAll = () => {
  return axios.get(`/api/webUsers/getAll`);
}
